import {Client} from "./client.model";
import {VetineoVisitTypeBundle} from "./vetineo-visit-type-bundle.model";
import {WellnessPlan} from "./wellness-plan.model";

/**
 * Reprezentuje konkretny typ wizyty (usługę) dostępny w ramach abonamentu użytkownika.
 * Łączy abstrakcyjny element planu z fizyczną definicją usługi (`VetineoVisitTypeBundle`).
 * Przechowuje status realizacji (czy usługa została już wykorzystana) oraz ramy czasowe ważności.
 */
export class UserCarePlanVetineoVisitTypeBundle {
  /** Unikalny identyfikator tego elementu w planie użytkownika. */
  public uuid: string;
  public created: Date;
  public deleted: Date;
  /** Data początkowa ważności tego konkretnego pakietu wizyt. */
  public itemStartDate: Date;
  /** Data wygaśnięcia (deadline na wykorzystanie wizyty). */
  public itemExpirationDate: Date;
  /**
   * Data faktycznego wykorzystania pakietu.
   * Jeśli ustawiona, oznacza to, że wizyta się odbyła i pakiet został zużyty.
   */
  public realizationDate: Date;
  public carePlanServiceUUID: string;
  public userCarePlanUUID: string;
  public vClientId: number;
  public vClient: Client;
  public userUUID: string;
  public mobilePhone: string;
  public email: string;
  public firstName: string;
  public lastName: string;
  public wellnessPlan: WellnessPlan;
  public wellnessPlanUUID: string;
  /**
   * Obiekt definicji typu wizyty.
   * Określa, jaką usługę użytkownik może umówić w ramach tego elementu planu.
   */
  public vetineoVisitTypeBundle: VetineoVisitTypeBundle;
  /** Referencja do definicji typu wizyty (klucz obcy). */
  public vetineoVisitTypeBundleUUID: string;

}
